module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "t-c clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "bold",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.detail.title))])]), _vm._v(" "), _c('div', {
    staticClass: "item ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.notice)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb7b0566"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/dashboard/noticeDetail.vue
// module id = 945
// module chunks = 0